export const STOCK_ORDER_LIST_ATTEMPT = "STOCK_ORDER_LIST_ATTEMPT";
export const STOCK_ORDER_LIST_SUCCESS = "STOCK_ORDER_LIST_SUCCESS";
export const STOCK_ORDER_LIST_FAILED = "STOCK_ORDER_LIST_FAILED";
//////////////////
export const STOCK_ORDER_NEW_SUCCESS = "STOCK_ORDER_NEW_SUCCESS";
export const STOCK_ORDER_NEW_FAILED = "STOCK_ORDER_NEW_FAILED";
///////////////////
export const STOCK_ORDER_REMOVE_SUCCESS = "STOCK_ORDER_REMOVE_SUCCESS";
export const STOCK_ORDER_REMOVE_FAILED = "STOCK_ORDER_REMOVE_FAILED";

export const STOCK_ORDER_SET_ITEM = "STOCK_ORDER_SET_ITEM";

